/**
 * AIJobStatus（SMALLINT）与前端字符串状态互转。
 * 后端枚举：1=pending 2=processing 3=completed 4=failed 5=cancelled
 */
export type AsyncJobStatus = 'pending' | 'processing' | 'completed' | 'failed' | 'cancelled';

export function normalizeAsyncJobStatus(status: unknown): AsyncJobStatus {
  if (typeof status === 'string') {
    const normalized = status.trim().toLowerCase();
    if (
      normalized === 'pending' ||
      normalized === 'processing' ||
      normalized === 'completed' ||
      normalized === 'failed' ||
      normalized === 'cancelled'
    ) {
      return normalized;
    }
    if (normalized === '1') return 'pending';
    if (normalized === '2') return 'processing';
    if (normalized === '3') return 'completed';
    if (normalized === '4') return 'failed';
    if (normalized === '5') return 'cancelled';
  }
  if (status === 1) return 'pending';
  if (status === 2) return 'processing';
  if (status === 3) return 'completed';
  if (status === 4) return 'failed';
  if (status === 5) return 'cancelled';
  return 'pending';
}

const ASYNC_JOB_STATUS_TO_CODE: Record<AsyncJobStatus, number> = {
  pending: 1,
  processing: 2,
  completed: 3,
  failed: 4,
  cancelled: 5,
};

export function resolveJobDisplayStatus(
  listStatus: number,
  liveStatus?: { status?: number | string } | null
): number {
  if (liveStatus?.status == null) return listStatus;
  return ASYNC_JOB_STATUS_TO_CODE[normalizeAsyncJobStatus(liveStatus.status)];
}
